import { Currency } from '@pulsex/sdk'
import { ChevronRightIcon, Flex, Text } from '@pulsex/uikit'
import { Fragment, memo } from 'react'
import { unwrappedToken } from 'utils/wrappedCurrency'

export default memo(function SwapRoute({ path }: { path?: Currency[] }) {
  return (
    <Flex flexWrap="wrap" width="100%">
      {path?.map((token, i) => {
        const isLastItem: boolean = i === path.length - 1
        const currency = (token.isToken && unwrappedToken(token)) || token
        return (
          // There might be same token appear more than once
          // eslint-disable-next-line react/no-array-index-key
          <Fragment key={`${currency?.symbol}_${i}`}>
            <Flex>
              <Text color="textSubtleDark" fontSize="14px" mx="0.125rem">
                {currency?.symbol}
              </Text>
            </Flex>
            {!isLastItem && <ChevronRightIcon color="textSubtleDark" width="16px" />}
          </Fragment>
        )
      })}
    </Flex>
  )
})
